import { ReactComponent as InfoBoxIcon } from '@Icons/additional/info-box.svg';

interface InformativeProps {
  description: string | JSX.Element;
}

const Informative: React.FC<InformativeProps> = ({ description }) => {
  return (
    <div className="trojan-informative">
      <div className="informative-caption">
        <InfoBoxIcon /> <span>Did You Know?</span>
      </div>
      <div className="informative-description">{description}</div>
    </div>
  );
};

export default Informative;
